/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_d50acee0"]'><div :class='["dialog-btn-slot-demo"]'><cube-button @_click="onClickDialog">Dialog - btn slot</cube-button><cube-dialog ref="__mpx_ref_dialog__" icon="info"><div slot="title">测试标题</div><div slot="btns" :class='["dialog-btn-slot"]'><div @tap='(e)=>__invoke(e, [["onCloseDialog"]])'>这是btn-slot</div></div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_d50acee0"}'>
@require "@mpxjs/mpx-cube-ui/src/common/stylus/variable.styl"
@require "@mpxjs/mpx-cube-ui/src/common/stylus/mixin.styl"

.dialog-btn-content
  text-align center
.dialog-btn-slot
  font-size 16px
  text-align center
  padding-top 14px
  padding-bottom 14px
  color #fc9153
  border-top-1px($var(border-color-normal))
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_d50acee0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_d50acee0"}
  /** script content **/
  require("./dialog-btn-slot.mpx.js?isComponent&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-btn-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-btn-slotd50acee0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_d50acee0"],
    ctorType: "component",
    outputPath: "components/dialog-btn-slotd50acee0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>